import { atom } from 'recoil';

export const warehousePrinterState = atom({
  key: 'warehouse_printer',
  default: [],
});
